import { Instance } from 'types/cluster';

const ASLEEP_STATUSES = new Set(['disconnected', 'sleeping']);

export const isClusterAsleep = (status?: string | null) =>
  Boolean(status && ASLEEP_STATUSES.has(status));

export const onDemandLoaderStatus = (
  instance: Pick<Instance, 'status' | 'loaderNodes' | 'onDemandLoader'>,
) => {
  const loader = instance.onDemandLoader;
  if (instance.status !== 'running' || instance.loaderNodes !== 1) return null;
  if (!loader?.supported) return null;
  if (loader.machineState === 'parked') return 'idle';
  if (loader.machineState === 'starting') return 'starting';
  return null;
};
